// @flow

import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

type Size = 'xsmall' | 'small' | 'medium' | 'large' | 'big' | 'bigger';
type Transparency = 'weak' | 'strong' | 'weaker';
type Use = 'default' | 'error' | 'success';
type Props = {
  children: React$Node,
  style?: { [string]: mixed },
  className?: string,
  size?: Size,
  transparency?: Transparency,
  use?: Use,
  bold?: boolean,
  noMargin?: boolean,
};

const P = ({
  children,
  style = {},
  className = '',
  size = 'medium',
  transparency,
  use = 'default',
  bold = false,
  noMargin = false,
}: Props) => (
  <p
    style={style}
    className={classnames(
      styles.p,
      styles[size],
      styles[transparency],
      styles[use],
      {
        [styles.bold]: bold,
        [styles.nomargin]: noMargin,
      },
      className,
    )}
  >
    {children}
  </p>
);

export default P;
